/*
 * Restaurant Order Core - frontend-utils.js
 * File Version: 1.0.1
 */
(function () {
  'use strict';

  function specialDayMode(settings, dateStr) {
    var map = (settings && settings.specialDays) || {};
    var entry = map[String(dateStr || '')];
    return (entry && typeof entry.mode === 'string') ? entry.mode : '';
  }

  function specialDayNote(settings, dateStr) {
    var map = (settings && settings.specialDays) || {};
    var entry = map[String(dateStr || '')];
    return (entry && typeof entry.note === 'string') ? entry.note : '';
  }

  function serviceAllowedOnDate(settings, dateStr, type) {
    var mode = specialDayMode(settings, dateStr);
    if (mode === 'closed') return false;
    if (mode === 'delivery_disabled' && type === 'delivery') return false;
    if (mode === 'pickup_disabled' && type === 'pickup') return false;
    return true;
  }

  function calendarDayState(settings, type, dateStr, todayStr, maxDateStr) {
    var d = String(dateStr || '');
    if (d < String(todayStr || '')) return { selectable: false, reason: 'past' };
    if (maxDateStr && d > String(maxDateStr)) return { selectable: false, reason: 'horizon' };
    var mode = specialDayMode(settings, d);
    if (mode === 'closed') return { selectable: false, reason: 'dateClosed' };
    if (mode === 'delivery_disabled' && type === 'delivery') return { selectable: false, reason: 'deliveryDayUnavailable' };
    if (mode === 'pickup_disabled' && type === 'pickup') return { selectable: false, reason: 'pickupDayUnavailable' };
    return { selectable: true, reason: '' };
  }

  var api = {
    specialDayMode: specialDayMode,
    specialDayNote: specialDayNote,
    serviceAllowedOnDate: serviceAllowedOnDate,
    calendarDayState: calendarDayState
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  if (typeof window !== 'undefined') {
    window.ROCFrontend = window.ROCFrontend || {};
    window.ROCFrontend.specialDayMode = specialDayMode;
    window.ROCFrontend.specialDayNote = specialDayNote;
    window.ROCFrontend.serviceAllowedOnDate = serviceAllowedOnDate;
    window.ROCFrontend.calendarDayState = calendarDayState;
  }
})();
